import { render } from "./InvitationTokenTemplate.vue?vue&type=template&id=8dd04fd0&scoped=true"
import script from "./InvitationTokenTemplate.vue?vue&type=script&lang=js"
export * from "./InvitationTokenTemplate.vue?vue&type=script&lang=js"

import "./InvitationTokenTemplate.vue?vue&type=style&index=0&id=8dd04fd0&lang=less&scoped=true"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8dd04fd0"]])

export default __exports__